import { render, staticRenderFns } from "./PaymentSingleSuccess.vue?vue&type=template&id=4baa2108"
import script from "./PaymentSingleSuccess.vue?vue&type=script&lang=js"
export * from "./PaymentSingleSuccess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports